import { useQueryClient } from '@tanstack/react-query';
import { useStore, useStoreActions } from '~/contexts';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
import { revenueOpportunitiesSummaryKey } from '~/utils/revenueOpportunities/revenueOpportunitiesQueryKeys';
export const useRevenueOpportunitiesSummary = function useRevenueOpportunitiesSummary() {
    let { refreshOnHookMount = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const businessId = useStore(selectors.user.businessId);
    const queryKey = revenueOpportunitiesSummaryKey(businessId !== null && businessId !== void 0 ? businessId : null);
    const { data, isLoading, isFetching, error, refresh } = useQueryState({
        queryKey,
        queryFn: ()=>api.pulse.getSummary(),
        enabled: businessId != null,
        refreshOnHookMount
    });
    function readSummaryState() {
        const state = queryClient.getQueryState(queryKey);
        return {
            summary: state === null || state === void 0 ? void 0 : state.data,
            isFetching: (state === null || state === void 0 ? void 0 : state.fetchStatus) === 'fetching'
        };
    }
    return {
        summary: data,
        isLoading,
        isFetching,
        error,
        refresh,
        readSummaryState
    };
};
